<template>
  <div class="home-page">
    
    <van-nav-bar>
      <template #title>
        <van-image src="img/home/logo3.png" width="60"></van-image>
      </template>
    </van-nav-bar>

    <div id="content">
      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>

      <div class="content">
        <div class="txt">
          <span> HOT </span>
          <span class="icon">{{ $t('index.title1') }}</span>
        </div>
        <div class="swiper_wrap">
          <div class="swiper" :style="{ width: `calc(${9.35 * xuanfeiList.length}rem)` }">
            <div v-for="item in xuanfeiList" :key="item.id" class="swipe" @click="goDetail(item)">
              <van-image :src="item.img_url[0]"></van-image>
              <div class="tip">
                <span>{{ $t('index.tip1') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title2') }}</div>
        <div class="ganeGroup">
          <div class="gameItem" v-for="item in gameList" :key="item.id" @click="goGame(item)">
            <div class="image">
              <van-image   :src="item.ico"></van-image>
            </div>
            <div class="label">{{ item.name }}</div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title3') }}</div>
        <div class="xuanfeiList">
          <div class="row" v-for="item in xuanfeiList" :key="item.id" @click="goDetail(item)">
            <div class="left">
              <van-image :src="item.img_url[0]"></van-image>
              <div>{{ item.xuanfei_name }}</div>
              <div class="tip">
                <span>{{ $t('index.tip2') }}</span>
              </div>
            </div>

            <div class="right">
              <div class="renzheng">
                <div>{{ $t('index.icon1') }}</div>
                <div>{{ $t('index.icon2') }}</div>
              </div>
              <div class="biaoqian">
                <div v-for="(biaoqian, index) in item.type.slice(0, 3)" :key="index">{{ biaoqian.name }}</div>
              </div>
              <div class="xingji">
                <div>
                  <span>{{ $t('index.label1') }}：</span>
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                  <van-icon name="star" color="#f4b757" size="1rem" />
                </div>
              </div>
              <div class="info">
                <div>{{ item.info }}</div>
              </div>
              <div class="button2">{{ $t('index.button') }}</div>
            </div>
          </div>
        </div>
        <div class="plCard">
          <div class="title">Live Feed</div>
          <swiper class="pl_swiper"  :options="plOption">
            <swiper-slide style="text-align: center; color: #6f6283;height: 1.5rem;line-height: 1.5rem;" v-for="(v, key) in plList" :key="key">{{ v }}</swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      tuis: [
        {
          id: 1,
          num: '001',
          name: '',
          pic: require("@/assets/imgs/index_pic/1.jpg"),
          avatar: require("@/assets/imgs/index_avatar/11.jpg"),
          sui: '22yo / 165cm / 46kg'
        },
        {
          id: 2,
          num: '002',
          name: '',
          pic: require("@/assets/imgs/index_pic/2.jpg"),
          avatar: require("@/assets/imgs/index_avatar/12.jpg"),
          sui: '26yo / 170cm / 53kg'
        },
        {
          id: 3,
          num: '003',
          name: '',
          pic: require("@/assets/imgs/index_pic/3.jpg"),
          avatar: require("@/assets/imgs/index_avatar/13.jpg"),
          sui: '21yo / 169cm / 51kg'
        },
        {
          id: 4,
          num: '004',
          name: '',
          pic: require("@/assets/imgs/index_pic/4.jpg"),
          avatar: require("@/assets/imgs/index_avatar/14.jpg"),
          sui: '23yo / 165cm / 49kg'
        },
        {
          id: 5,
          num: '005',
          name: '',
          pic: require("@/assets/imgs/index_pic/5.jpg"),
          avatar: require("@/assets/imgs/index_avatar/15.jpg"),
          sui: '25yo / 167cm / 50kg'
        },
        {
          id: 6,
          num: '006',
          name: '',
          pic: require("@/assets/imgs/index_pic/6.jpg"),
          avatar: require("@/assets/imgs/index_avatar/16.jpg"),
          sui: '22yo / 162cm / 47kg'
        },
        {
          id: 7,
          num: '007',
          name: '',
          pic: require("@/assets/imgs/index_pic/7.jpg"),
          avatar: require("@/assets/imgs/index_avatar/17.jpg"),
          sui: '34yo / 170cm / 54kg'
        },
        {
          id: 8,
          num: '008',
          name: '',
          pic: require("@/assets/imgs/index_pic/8.jpg"),
          avatar: require("@/assets/imgs/index_avatar/18.jpg"),
          sui: '30yo / 166cm / 49kg'
        },
        {
          id: 9,
          num: '009',
          name: '',
          pic: require("@/assets/imgs/index_pic/9.jpg"),
          avatar: require("@/assets/imgs/index_avatar/19.jpg"),
          sui: '24yo / 172cm / 52kg'
        },
        {
          id: 10,
          num: '010',
          name: '',
          pic: require("@/assets/imgs/index_pic/10.jpg"),
          avatar: require("@/assets/imgs/index_avatar/20.jpg"),
          sui: '22yo / 168cm / 49kg'
        }
      ],
      bannerSwiperOption: {
        autoplay: true,
      },
      xuanfeiList: [],
      gameList: [],
      plList: [
        'jx***ib has signed up',
        '95***8f has signed up',
        '71***8c completed a match',
        'xf***45 completed a match',
        'rw***32 completed a match',
        '5n***8m completed a match',
        'bv***f3 has signed up',
        '44***uc has signed up',
        'xo***n0 completed a match',
        'xm***19 has signed up',
        'ha***2g completed a match',
        'or***ze completed a match',
        'df***ux completed a match',
        'zb***is completed a match',
        'ud***c3 has signed up',
        'n8***42 has signed up',
        'm3***r8 has signed up',
        'p1***5a has signed up',
        'ab***9e has signed up',
        '0v***dz has signed up',
        'jx***ib has signed up',
        '95***8f has signed up',
        '71***8c completed a match',
        'xf***45 completed a match',
        'rw***32 completed a match',
        '5n***8m completed a match',
        'bv***f3 has signed up',
        '44***uc has signed up',
        'xo***n0 completed a match',
        'xm***19 has signed up'
      ],
      plOption: {
        autoplay: true,
        direction: 'vertical',
        slidesPerView: 5,
        speed: 800,
      }
    }
  },
  computed: {
    swipeWidth() {
      return window.innerWidth * 0.45
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.banners = res.data?.banners || [];
      })

    },

    getXuanfeiList() {
      this.$http({
        method: 'get',
        url: 'xuanfei_list'
      }).then(res => {
        if (res.code === 200) {
          this.xuanfeiList = res.data.data.map(item => {
            item.info = `Height: ${item.height}cm  Size: ${item.bust}  Available Area: ${item.diqu}`
            return item
          })
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

    goDetail(e) {
      localStorage.setItem('xuanfeiDetail', JSON.stringify(e))
      this.$router.push(`XuanfeiDetail`);
    },

    goGame(e) {
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/WindowLottery?key='+e.key+"&id="+e.id})
      }
    },

    
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameList = res.data;
      })
    },
  },
  created() {
    this.getBasicConfig();
    this.getGameItem()
    this.getXuanfeiList()
  }
}
</script>


<style lang="less" scoped>
@import '~@/assets/css/theme.less';

.home-page {
  min-height: 100%;
  background: @bg-page;
}

.home-page .van-nav-bar {
  background: linear-gradient(120deg, rgba(243, 156, 190, 0.95) 0%, rgba(189, 160, 240, 0.95) 55%, rgba(255, 178, 145, 0.95) 100%);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 0.2rem 0.8rem rgba(183, 156, 236, 0.15);
}

#content{
  padding-bottom: 3.2rem;
}

.banner {
  padding: 0.75rem 4% 0;
}

.banner_swiper {
  // padding-top: 5%;
  height: 100%;
  width: 100%;
  border-radius: 1.3rem;
  overflow: hidden;
  box-shadow: 0 0.6rem 1.6rem rgba(183, 156, 236, 0.28);

  .swiper-slide {
    // border-radius: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 19.375rem;
    width: 100%;
    height: 10.375rem;
    text-align: center;
    font-weight: bold;
    font-size: 0.625rem;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  .banner_img {
    border-radius: 0;
    width: 100%;
    height: 100%;
  }
}

.content {
  width: 90%;
  margin: 0 auto;

  .txt {
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: 0.02rem;
    color: @text-title;
    margin-top: 5%;
    margin-bottom: 5%;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 0.28rem;
      height: 1.05rem;
      border-radius: @radius-pill;
      background: @grad-primary;
      margin-right: 0.5rem;
      box-shadow: 0 0.15rem 0.4rem rgba(245, 154, 184, 0.4);
    }
    .icon{
      display: inline-block;
      margin-left: .46667rem;
      border-radius: @radius-pill;
      background: @grad-pink-lavender;
      color: #fff;
      font-weight: 500;
      padding: .04rem .6rem;
      font-size: 0.88rem;
      box-shadow: 0 0.2rem 0.6rem rgba(245, 154, 184, 0.3);
    }
  }


  .swiper_wrap {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .swiper {
      display: flex;
      scroll-snap-type: x mandatory;

      .swipe {
        flex-shrink: 0;
        scroll-snap-align: start;
        width: 8.67rem;
        height: 8.67rem;
        overflow: hidden;
        margin-right: .67rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-radius: 1.15rem;
        border: 2px solid rgba(255, 255, 255, 0.9);
        box-shadow: @shadow-soft;

        ::v-deep .van-image__img {
          border-radius: 1.15rem;
        }

        .tip {

          position: absolute;
          z-index: 9;
          background: @grad-peach;
          color: #fff;
          width: 6.8rem;
          height: 6.8rem;
          transform: rotate(45deg);
          left: 5.66667rem;
          top: -4rem;

          span {

            position: absolute;
            bottom: 0;
            left: 1.6rem;
            font-size: .76667rem;
            font-weight: 600;
          }
        }
      }
    }
  }

  .xuanfeiList {
    .row {
      display: flex;
      width: 100%;
      border: none;
      background: rgba(255, 255, 255, 0.72);
      border-radius: 1.3rem;
      box-shadow: 0 0.5rem 1.4rem rgba(183, 156, 236, 0.16);
      padding: 0.75rem;
      margin-bottom: 0.85rem;
      align-items: center;

      .left {
        width: 7rem;
        text-align: center;
        color: @text-title;
        position: relative;
        overflow: hidden;
        border-radius: 1rem;

        ::v-deep .van-image__img {
          border-radius: 1rem;
        }

        .tip {
          position: absolute;
          transform: rotate(45deg);
          right: -5.66667rem;
          width: 6.66667rem;
          height: 6.66667rem;
          top: -3.33333rem;
          background: @grad-peach;
          color: #fff;
          opacity: .95;

          span {
            position: absolute;
            font-weight: 600;
            left: .8rem;
            bottom: 0;
            font-size: .8rem;
          }
        }
      }

      .right {
        flex: 1;
        padding-left: 0.67rem;
        max-width: calc(100% - 7.67rem);

        .renzheng {
          display: flex;
          flex-wrap: wrap;
          gap: 0.35rem 0.4rem;

          >div {
            background: linear-gradient(120deg, @lavender-light, @peach-light);
            border: 1px solid rgba(183, 156, 236, 0.45);
            color: #8a63c9;
            font-weight: 600;
            margin-left: 0;
            padding: .16rem .4rem;
            font-size: .73333rem;
            border-radius: @radius-pill;
            max-width: 100%;
            white-space: nowrap;
            display: flex;
            align-items: center;

            &::before {
              content: '';
              width: .8125rem;
              height: .8125rem;
              background: url('/public/img/home/icon.png');
              background-size: 100% 100%;
            }
          }
        }

        .biaoqian {
          display: flex;
          flex-wrap: wrap;
          padding: 0.3rem 0;

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: .2rem .4rem;
            margin: .16667rem .16667rem;
            border-radius: @radius-pill;
            font-size: .76667rem;

            &:nth-child(1n) {
              background-color: #ffeaf1;
              color: #e0739b;
              border: 1px solid rgba(245, 154, 184, 0.6);
            }

            &:nth-child(2n) {
              background-color: #fff0e7;
              color: #e8895c;
              border: 1px solid rgba(255, 184, 148, 0.7);
            }

            &:nth-child(3n) {
              background-color: #f2ecff;
              color: #8a63c9;
              border: 1px solid rgba(183, 156, 236, 0.6);
            }
          }
        }

        .xingji {
          color: @text-body;
          font-size: .9rem;
          padding-bottom: .3rem;
        }

        .info {
          overflow: hidden;

          >div {

            font-size: .9rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: @text-sub;
          }
        }

        .button2 {
          text-align: center;
          background: @grad-primary;
          box-shadow: 0 0.25rem 0.8rem rgba(245, 154, 184, 0.3);
          font-weight: 500;
          color: #fff;
          border-radius: @radius-pill;
          padding: .33333rem 0;
          width: 90%;
          margin: .33333rem 0 .66667rem;
          max-width: 20rem;
        }
      }
    }
  }

  .ganeGroup{
    display: flex;
    background: rgba(255, 255, 255, 0.72);
    border-radius: 1.3rem;
    box-shadow: 0 0.5rem 1.4rem rgba(183, 156, 236, 0.16);
    padding: 1rem 0.4rem;
    .gameItem{
      flex: 1;
      text-align: center;
    }
    .image{
      width: 70%;
      height: 6rem;
      margin: 0 auto;
    }
    .label{
      font-size: 1rem;
      padding-top: .7rem;
      font-weight: 500;
      color: @text-title;
    }
    .van-image{
      width: 100%;
      height: 100%;
    }
  }

  .plCard{
    width: 100%;
    margin: 0 auto 1.25rem;
    height: 11.25rem;
    padding: 0.63rem 1.25rem;
    background: rgba(255, 255, 255, 0.72);
    border-radius: 1.3rem;
    border: 1px solid rgba(255, 255, 255, 0.85);
    box-shadow: 0 0.5rem 1.4rem rgba(183, 156, 236, 0.16);
    .title{
      background: @grad-primary;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-weight: 700;
      letter-spacing: 0.08rem;
      font-size: 1.19rem;
      text-align: center;
      margin-bottom: 0.63rem;
    }
    .pl_swiper{
      height: 7.5rem;
    }
  }
}
</style>